(function () {
  var COVERAGE_BADGE = {
    titular: { className: "stdb-badge stdb-badge--titular", label: "Solo para ti" },
    nucleo: { className: "stdb-badge", label: "Para ti y tu familia" },
    mixto: {
      className: "stdb-badge",
      label: "Gratis para ti, precio preferente para tu familia",
    },
  };

  var MODAL_BY_HASH = {
    "#privacidad": "stdb-modal-privacidad",
    "#terminos": "stdb-modal-terminos",
  };

  function escapeHTML(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function linkifySite(value) {
    return escapeHTML(value).replace(
      /https?:\/\/asistencias\.erasocial\.(?:com|mx)|asistencias\.erasocial\.(?:com|mx)/g,
      '<a class="stdb-site-link" href="https://asistencias.erasocial.com" target="_blank" rel="noopener noreferrer">asistencias.erasocial.com</a>'
    );
  }

  function iconUrl(filename) {
    if (!filename) return "";
    var map = window.STDB_ICON_MAP || {};
    if (map[filename]) return map[filename];
    return filename;
  }

  function renderList(items) {
    items = items || [];
    if (!items.length) return "";
    return (
      "<ul>" +
      items
        .map(function (item) {
          return "<li>" + escapeHTML(item) + "</li>";
        })
        .join("") +
      "</ul>"
    );
  }

  function renderFaqs(faqs) {
    faqs = faqs || [];
    if (!faqs.length) return "";
    return (
      "<h4>Preguntas frecuentes</h4><div class=\"stdb-faq-list\">" +
      faqs
        .map(function (faq) {
          return (
            "<details><summary>" +
            escapeHTML(faq.question) +
            "</summary><p>" +
            linkifySite(faq.answer) +
            "</p></details>"
          );
        })
        .join("") +
      "</div>"
    );
  }

  function renderDetailBlock(block) {
    if (!block) return "";
    var html = "";
    if (block.includes && block.includes.length) {
      html += "<h4>Beneficios</h4>" + renderList(block.includes);
    }
    if (block.schedule) {
      html += "<h4>Ventana de servicio</h4><p>" + escapeHTML(block.schedule) + "</p>";
    }
    if (block.limits) {
      html += "<h4>Límites y variables</h4><p>" + escapeHTML(block.limits) + "</p>";
    }
    return html;
  }

  function renderSections(sections) {
    sections = sections || [];
    if (!sections.length) return "";
    return sections
      .map(function (section) {
        return (
          '<article class="stdb-benefit-section">' +
          '<h3 class="stdb-benefit-section__title">' +
          escapeHTML(section.title) +
          "</h3>" +
          (section.summary ? "<p>" + escapeHTML(section.summary) + "</p>" : "") +
          renderDetailBlock(section) +
          "</article>"
        );
      })
      .join("");
  }

  function renderBenefit(item) {
    var badge = COVERAGE_BADGE[item.coverage] || COVERAGE_BADGE.mixto;
    var src = iconUrl(item.icon);
    var icon = src
      ? '<img class="stdb-accordion__icon" src="' +
        escapeHTML(src) +
        '" alt="" width="48" height="48" loading="lazy" />'
      : "";
    var hasSections = Array.isArray(item.sections) && item.sections.length > 0;
    return (
      '<details class="stdb-accordion__item" id="beneficio-' +
      escapeHTML(item.handle) +
      '" data-stdb-handle="' +
      escapeHTML(item.handle) +
      '">' +
      '<summary class="stdb-accordion__summary">' +
      icon +
      '<span class="stdb-accordion__text">' +
      escapeHTML(item.title) +
      '<span class="stdb-accordion__meta"><span class="' +
      badge.className +
      '">' +
      badge.label +
      "</span></span></span>" +
      '<span class="stdb-accordion__toggle" aria-hidden="true">' +
      '<svg width="14" height="14" viewBox="0 0 14 14" fill="none">' +
      '<path d="M7 2.5v9M2.5 7h9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
      "</svg></span></summary>" +
      '<div class="stdb-accordion__panel">' +
      (item.summary ? "<p>" + escapeHTML(item.summary) + "</p>" : "") +
      (hasSections ? renderSections(item.sections) : renderDetailBlock(item)) +
      renderFaqs(item.faqs) +
      "</div></details>"
    );
  }

  function renderBenefitGroup(title, items) {
    if (!items.length) return "";
    return (
      '<div class="stdb-group"><h3 class="stdb-group__title">' +
      escapeHTML(title) +
      '</h3><div class="stdb-accordion">' +
      items.map(renderBenefit).join("") +
      "</div></div>"
    );
  }

  function renderIntro(intro) {
    if (!intro) return "";
    var notes = (intro.notes || [])
      .map(function (note) {
        return "<li>" + linkifySite(note) + "</li>";
      })
      .join("");
    if (!notes) return "";

    return (
      '<aside class="stdb-intro" aria-label="Información importante">' +
      '<ul class="stdb-intro__notes">' +
      notes +
      "</ul></aside>"
    );
  }

  function renderPage(data) {
    var items = (data.items || []).slice().sort(function (a, b) {
      return (a.order || 0) - (b.order || 0);
    });
    var salud = items.filter(function (item) {
      return item.category === "salud";
    });
    var vida = items.filter(function (item) {
      return item.category === "vida_diaria";
    });

    return (
      '<div class="stdb-page">' +
      '<section class="stdb-section stdb-reveal" id="beneficios" aria-labelledby="stdb-beneficios-title">' +
      '<div class="stdb-section__heading">' +
      '<h1 class="stdb-section__title" id="stdb-beneficios-title">Beneficios</h1>' +
      (window.STDB_LOGO_URL
        ? '<img class="stdb-section__logo" src="' +
          escapeHTML(window.STDB_LOGO_URL) +
          '" alt="Salud Total Dondé" width="220" height="48" decoding="async" />'
        : "") +
      "</div>" +
      '<p class="stdb-section__lead">' +
      escapeHTML(data.benefits_intro || "") +
      "</p>" +
      renderBenefitGroup(data.salud_group_title || "Asistencias de Salud", salud) +
      renderBenefitGroup(data.vida_group_title || "Servicios de Vida Diaria", vida) +
      renderIntro(data.intro) +
      "</section>" +
      '<footer class="stdb-legal-links stdb-reveal" aria-label="Documentos legales">' +
      '<p class="stdb-legal-links__row">' +
      '<button type="button" id="privacidad" class="stdb-legal-links__item" data-stdb-open-modal="stdb-modal-privacidad">Aviso de Privacidad</button>' +
      '<span class="stdb-legal-links__sep" aria-hidden="true"> / </span>' +
      '<button type="button" id="terminos" class="stdb-legal-links__item" data-stdb-open-modal="stdb-modal-terminos">Términos y Condiciones</button>' +
      "</p></footer></div>"
    );
  }

  function observeReveals(root) {
    var nodes = root.querySelectorAll(".stdb-reveal");
    if (!nodes.length) return;

    if (!("IntersectionObserver" in window)) {
      nodes.forEach(function (node) {
        node.classList.add("stdb-is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("stdb-is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16, rootMargin: "0px 0px -8% 0px" }
    );

    nodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  function getRoot() {
    return document.querySelector(".stdb-root");
  }

  function openModal(id) {
    var root = getRoot();
    var modal = document.getElementById(id);
    if (!modal) return;
    closeAllModals();
    modal.hidden = false;
    if (root) root.classList.add("is-stdb-modal-open");
    document.documentElement.style.overflow = "hidden";
    var closeBtn = modal.querySelector(".stdb-modal__close");
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    var root = getRoot();
    var anyOpen = root && root.querySelector(".stdb-modal:not([hidden])");
    if (!anyOpen) {
      if (root) root.classList.remove("is-stdb-modal-open");
      document.documentElement.style.overflow = "";
    }
  }

  function closeAllModals() {
    document.querySelectorAll(".stdb-modal").forEach(function (modal) {
      modal.hidden = true;
    });
    var root = getRoot();
    if (root) root.classList.remove("is-stdb-modal-open");
    document.documentElement.style.overflow = "";
  }

  function bindModals(root) {
    root.addEventListener("click", function (event) {
      var openBtn = event.target.closest("[data-stdb-open-modal]");
      if (openBtn) {
        event.preventDefault();
        openModal(openBtn.getAttribute("data-stdb-open-modal"));
        return;
      }
      var closeEl = event.target.closest("[data-stdb-modal-close]");
      if (closeEl) {
        event.preventDefault();
        closeModal(closeEl.closest(".stdb-modal"));
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      closeAllModals();
    });
  }

  function scrollToHash() {
    var hash = window.location.hash;
    if (!hash) return;

    if (MODAL_BY_HASH[hash]) {
      openModal(MODAL_BY_HASH[hash]);
      return;
    }

    var root = getRoot();
    var target = (root && root.querySelector(hash)) || document.querySelector(hash);
    if (!target) return;
    requestAnimationFrame(function () {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  function readEmbedded() {
    var el = document.getElementById("stdb-content-data");
    if (!el) return null;
    var text = (el.textContent || "").trim();
    if (!text || text === "null") return null;
    try {
      return JSON.parse(text);
    } catch (err) {
      console.error("[stdb] JSON inválido en metafield", err);
      return null;
    }
  }

  var STDB_MIN_LOAD_MS = 700;

  function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  async function loadContent() {
    var embedded = readEmbedded();
    if (embedded && embedded.items) return embedded;
    throw new Error("Sin metaobject stdb_content (campo data) seleccionado en la section");
  }

  async function init() {
    var root = document.querySelector(".stdb-root");
    if (!root) return;
    var app = root.querySelector(".stdb-app") || root;
    var startedAt = Date.now();

    try {
      var data = await loadContent();
      var elapsed = Date.now() - startedAt;
      if (elapsed < STDB_MIN_LOAD_MS) {
        await wait(STDB_MIN_LOAD_MS - elapsed);
      }
      app.innerHTML = renderPage(data);
      app.removeAttribute("aria-busy");
      observeReveals(app);
      bindModals(root);
      window.addEventListener("hashchange", scrollToHash);
      scrollToHash();
      setTimeout(scrollToHash, 120);
    } catch (error) {
      console.error(error);
      var errElapsed = Date.now() - startedAt;
      if (errElapsed < STDB_MIN_LOAD_MS) {
        await wait(STDB_MIN_LOAD_MS - errElapsed);
      }
      app.removeAttribute("aria-busy");
      app.innerHTML =
        '<p class="stdb-status stdb-status--error" role="status">' +
        "No se pudo cargar el contenido. En el editor del tema, elige el metaobject STD Contenido " +
        "(campo data con el JSON)." +
        "</p>";
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
